export default __webpack_public_path__ + "static/media/logo.f1c4b959.svg";